import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled, css } from 'styled-components';

const EmbedWrapper = styled.div.withConfig({
  displayName: "EmbedWrapper",
  componentId: "sc-db091ef6-0"
})([
  `display:flex;align-items:center;justify-content:center;background:`,
  `;border-radius:6px;overflow:hidden;flex-shrink:0;`,
  ``
], cssVar["color-bg-secondary"], (p) => p.orientation === "vertical" ? css([
  `width:max-content;margin:0 auto;max-width:100%;iframe{aspect-ratio:9 / 16;}`
]) : css([
  `iframe{width:100%;aspect-ratio:16 / 9;}`
]));

export { EmbedWrapper };
//# sourceMappingURL=EmbedWrapper.js.map
